const LanguageSwitch = require('./default');

window.$dependencyManager.addDependencyCallback('gsap', () => {
  jQuery('.mad-language-switch__container').each((index, languageSwitch) => {
    const $languageSwitch = jQuery(languageSwitch);
    new LanguageSwitch($languageSwitch);
    // console.log('Initialized LanguageSwitch for element', $languageSwitch);
  });
});
